import { Alert, AlertDescription, AlertIcon, AlertTitle, CloseButton } from "@chakra-ui/react"
import { toastErrDesc } from "../../utils/toastUtils"

const AlertError = ({ error }) => {
    return (
        <Alert status="error">
            <AlertIcon />
            <AlertTitle mr={2}>พบข้อผิดพลาด</AlertTitle>
            <AlertDescription>{toastErrDesc(error)}</AlertDescription>
            <CloseButton position="absolute" right="8px" top="8px" />
        </Alert>
    )
}

export default AlertError